var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.42749C4.05 1.42749 1.25 4.22749 1.25 7.67749C1.25 11.1275 4.05 13.9275 7.5 13.9275C10.95 13.9275 13.75 11.1275 13.75 7.67749C13.75 4.22749 10.95 1.42749 7.5 1.42749ZM7.5 3.30249C8.5375 3.30249 9.375 4.13999 9.375 5.17749C9.375 6.21499 8.5375 7.05249 7.5 7.05249C6.4625 7.05249 5.625 6.21499 5.625 5.17749C5.625 4.13999 6.4625 3.30249 7.5 3.30249ZM7.5 12.1775C5.9375 12.1775 4.55625 11.3775 3.75 10.165C3.76875 8.92124 6.25 8.23999 7.5 8.23999C8.74375 8.23999 11.2313 8.92124 11.25 10.165C10.4438 11.3775 9.0625 12.1775 7.5 12.1775Z",
    fill: "#B12D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/MyAccount.3be20dd869d2242f88d9833785849c73.svg";
export { ForwardRef as ReactComponent };